import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FlyingClubFinderFilter } from '../models/flying-club-finder-filter.model';

/**
 * Shares the Flying Club Finder filter state between the landing page, the results page, and the
 * filter-list component. Mirrors {@link AviationEventFiltersService} (a root-provided BehaviorSubject).
 */
@Injectable({
  providedIn: 'root'
})
export class FlyingClubFinderFiltersService {

  private flyingClubFinderFilterSubject$ = new BehaviorSubject<FlyingClubFinderFilter>(new FlyingClubFinderFilter());
  flyingClubFinderFilter = this.flyingClubFinderFilterSubject$.asObservable();

  constructor() { }

  updateFlyingClubFinderFilters(flyingClubFinderFilter: FlyingClubFinderFilter) {
    this.flyingClubFinderFilterSubject$.next(flyingClubFinderFilter);
  }
}
